window.documentReady(() => {
	// Mobile navigation toggling
	const mobileNavToggle = document.querySelectorAll('.toggle-mobile-nav')
	if(mobileNavToggle.length === 1){
		mobileNavToggle[0].addEventListener('click', (e) => {
			e.preventDefault()
			const classOpened = 'mobile-nav-opened'
			const hasOpenedClass = window.hasClass(document.body, classOpened)

			// hide all
			$('.submenu-item, .small-submenu').removeClass('shown')
			$('[data-toggle="submenu"]').removeClass('active')
			$('body').removeClass('subnav-opened')

			if(hasOpenedClass) {
				window.removeClass(document.body, classOpened)
			} else {
				window.addClass(document.body, classOpened)
			}
		})
	}

	// submenu toggler
	$('[data-toggle="submenu"]').click((e) => {
		e.preventDefault()

		const toggleItem = $(e.currentTarget)
		const targetItem = $(toggleItem.attr('href'))

		if(targetItem.length) {
			// hide all
			$('.submenu-item, .small-submenu').not(targetItem).removeClass('shown')
			$('[data-toggle="submenu"]').not(toggleItem).removeClass('active')

			// toggle related one
			toggleItem.toggleClass('active')
			targetItem.toggleClass('shown')
			if(toggleItem.hasClass('active')){
				// enable backdrop
				$('body').addClass('subnav-opened')

			} else {
				// disable backdrop
				$('body').removeClass('subnav-opened')
			}
		} else {
			console.error('Related submenu element not found.')
		}
	})

	$('.backdrop').click((e) => {
		e.preventDefault()
		e.stopPropagation()

		// hide all
		$('.submenu-item, .small-submenu').removeClass('shown')
		$('[data-toggle="submenu"]').removeClass('active')
		$('body').removeClass('subnav-opened')
	})

	/*
		Galleries and sliders
	 */

	const hpHeaderSlider = () => {
		const $slider = $('.hp-slider .carousel')
		if(!$slider.length) { return }

		const $carouselNav = $slider.parent().find('.carousel-nav')

		$slider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: false,
			autoplay: false,
			appendArrows: $carouselNav,
			dots: false,
			prevArrow: $carouselNav.find('.prev-slide'),
			nextArrow: $carouselNav.find('.next-slide'),
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 481,
					settings: {
						slidesToShow: 1
					}
				},
			]
		})
	}

	const showcaseSlider = () => {
		const $slider = $('.showcase-slider .carousel')
		if(!$slider.length) { return }

		const $carouselNav = $slider.parent().find('.carousel-nav')

		$slider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: false,
			appendArrows: $carouselNav,
			dots: false,
			prevArrow: $carouselNav.find('.prev-slide'),
			nextArrow: $carouselNav.find('.next-slide'),
			responsive: [
				//{ breakpoint: 500, settings: {slidesToShow: 1}},
			]
		})
	}

	const testimonialSlider = () => {
		const $slider = $('.testimonials-slider .carousel')
		if(!$slider.length) { return }

		const $carouselNav = $slider.parent().find('.carousel-nav')

		$slider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 2000,
			appendArrows: $carouselNav,
			dots: false,
			prevArrow: $carouselNav.find('.prev-slide'),
			nextArrow: $carouselNav.find('.next-slide'),
			responsive: [
				//{ breakpoint: 500, settings: {slidesToShow: 1}},
			]
		})
	}

	const footerLogoSlider = () => {
		const $slider = $('.footer-logo-slider .carousel')
		if(!$slider.length) { return }

		$slider.slick({
			slidesToShow: 7,
			slidesToScroll: 1,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 2000,
			dots: false,
			arrows: false,
			responsive: [
				{ breakpoint: 1440, settings: {slidesToShow: 5}},
				{ breakpoint: 1024, settings: {slidesToShow: 4}},
				{ breakpoint: 767, settings: {slidesToShow: 3}},
				{ breakpoint: 550, settings: {slidesToShow: 2}},
			]
		})
	}

	const gallerySlider = () => {
		const $slider = $('.gallery.carousel')
		const $carouselNav = $slider.closest('.gallery-carousel-wrapper').find('.gallery-nav-carousel')
		if(!$slider.length || !$carouselNav.length) { return }

		const $sliderNav = $carouselNav.find('.nav.carousel')
		const $sliderNavArrows = $carouselNav.find('.carousel-nav')

		$slider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			infinite: false,
			asNavFor: $sliderNav
		})

		// related navigation carousel
		$sliderNav.slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			appendArrows: $sliderNavArrows,
			asNavFor: $slider,
			dots: false,
			infinite: false,
			focusOnSelect: true,
			prevArrow: $sliderNavArrows.find('.prev-slide'),
			nextArrow: $sliderNavArrows.find('.next-slide'),
			responsive: [
				{ breakpoint: 992, settings: {slidesToShow: 3}},
				{ breakpoint: 500, settings: {slidesToShow: 2}},
			]
		})
	}

	const simpleGallerySlider = () => {
		const $slider = $('.simple-gallery.carousel')
		if(!$slider.length) { return }

		const $carouselNav = $slider.parent().find('.carousel-nav')

		$slider.slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			infinite: true,
			appendArrows: $carouselNav,
			dots: false,
			prevArrow: $carouselNav.find('.prev-slide'),
			nextArrow: $carouselNav.find('.next-slide'),
			responsive: [
				{ breakpoint: 992, settings: {slidesToShow: 3}},
				{ breakpoint: 500, settings: {slidesToShow: 2}},
			]
		})
	}

	gallerySlider()
	simpleGallerySlider()
	hpHeaderSlider()
	showcaseSlider()
	testimonialSlider()
	footerLogoSlider()

	// Scroll links - scroll to anchor
	document.querySelectorAll('a[data-toggle="scroll"]').forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault()
			let targetElement = document.getElementById(link.getAttribute('href').substr(1))
			window.scrollToElement(document.documentElement, targetElement.offsetTop);
		})
	})


})

window.addEventListener('scroll', () => {
	let header = document.querySelectorAll('div.header')
	const startedOffset = 10
	const pageOffset = window.pageYOffset

	if(header.length !== 1) {
		return
	} else {
		header = header[0]
	}

	// ak header dosiahol hranicu alebo je POD nou, zapni class
	if (pageOffset >= startedOffset) {
		if (false === window.hasClass(header, 'header-scrolling')) {
			window.addClass(header, 'header-scrolling')
			window.addClass(document.body, 'scrolling')
		}
	}

	// ak je header NAD hranicou, vypni class
	if (pageOffset < startedOffset) {
		if (true === window.hasClass(header, 'header-scrolling')) {
			window.removeClass(header, 'header-scrolling')
			window.removeClass(document.body, 'scrolling')
		}
	}
})

